import { render, staticRenderFns } from "./RegionsTab.vue?vue&type=template&id=34a1db5e"
import script from "./RegionsTab.vue?vue&type=script&lang=js"
export * from "./RegionsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports